export const selectCompanyProfile = (state) => state.companyProfileReducer.companyProfile;
export const selectCompanyProfileLoading = (state) => state.companyProfileReducer.companyProfileLoading;
